// NOTE: This is duplicated with RefreshButton, in both Playground and Sandbox. At some point I should consolidate, but it's tricky since the rotation logic can't be self-contained (since a parent button will be clicked to trigger the rotation).

'use client';

import React from 'react';
import { styled } from '@linaria/react';
import { RefreshCw } from 'lucide-react';
import { useSpring, animated } from 'react-spring';

import { IconProps } from './Icon.types';

interface Props extends IconProps {
  changeKey: any;
}

export function IconRefresh({
  size = 20,
  isBooped,
  changeKey,
  ...delegated
}: Props) {
  const [rotation, setRotation] = React.useState(0);
  const initialChangeKeyRef = React.useRef(changeKey);

  React.useEffect(() => {
    // Ignore the initial mount
    if (changeKey === initialChangeKeyRef.current) {
      return;
    }

    // Whenever `changeKey` changes after that, increment rotation by 180 degrees
    setRotation((r) => r + 180);
  }, [changeKey]);

  const spring = useSpring({
    transform: `rotate(${isBooped ? rotation - 64 : rotation}deg)`,
  });

  return (
    <Wrapper style={spring}>
      <RefreshCw size={size} />
    </Wrapper>
  );
}

const Wrapper = styled(animated.span)`
  display: block;
`;

export default IconRefresh;
